import { SummaryBadgeColors, trackExperimentBannerState } from 'modules/experiments/constants';
import { getExperimentSummaryBadgeMetadata } from 'modules/experiments/ducks/selectors';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import {
  getExperimentSummaryBannerDisplayItemsFromMapping,
  humanizeMinutesDisplay,
} from 'modules/experiments/utils';
import { ExperimentState } from 'modules/graphql';
import { useSelector } from 'react-redux';
import { MONITOR_PAGE, useRumAction } from 'services/observability/datadog';
import { ExperimentSummaryStatusBadge } from './StatusBadge';
import {
  StyledExperimentSummarySecondaryText,
  StyledExperimentsSummaryInfoBanner,
  StyledExperimentsTextContainer,
  StyledTextHeader,
} from './Styled';

export const ExperimentSummaryInfoBanner = () => {
  const { t } = useExperimentsTranslations();
  const addSignal = useRumAction(MONITOR_PAGE);
  const {
    experimentState,
    variantWinnerType,
    randomlySplitVariations,
    campaignType,
    winnerName,
    winnerLift,
    totalUserSends,
    experimentTestPeriod,
    minutesLeftInExperiment,
    testSendsPerVariation,
  } = useSelector(getExperimentSummaryBadgeMetadata);
  if (
    experimentState === ExperimentState.ERRORED ||
    experimentState === ExperimentState.CANCELLED
  ) {
    return null;
  }

  const displayData = getExperimentSummaryBannerDisplayItemsFromMapping({
    experimentState,
    variantWinnerType,
    randomlySplitVariations,
    campaignType,
  });

  const primaryText = t(displayData?.primaryText, {
    winner_name: winnerName,
    lift_pp: winnerLift,
    total_sends: totalUserSends,
    test_duration_in_hours_minutes: humanizeMinutesDisplay(t, experimentTestPeriod),
    hours_mins_left_in_experiment: humanizeMinutesDisplay(t, minutesLeftInExperiment),
    test_sends_per_variation: testSendsPerVariation,
  });
  const secondaryText = t(displayData?.secondaryText, { lift_pp: winnerLift });

  // We shouldn't be showing the experiment is still in progress banner
  // If the mins left is 0 mins. So, we want to track these experiments
  if (
    minutesLeftInExperiment === 0 &&
    trackExperimentBannerState.includes(displayData?.primaryText)
  ) {
    addSignal('INVALID_EXPERIMENT_BANNER_STATE', {
      bannerText: displayData?.primaryText,
    });
  }

  return (
    <StyledExperimentsSummaryInfoBanner data-test={'experiment-summary-info-banner'}>
      <ExperimentSummaryStatusBadge
        includesSubText={!!secondaryText}
        color={displayData?.iconColor || SummaryBadgeColors.Grey}
      />
      <StyledExperimentsTextContainer includesSubText={!!secondaryText}>
        <StyledTextHeader>{primaryText}</StyledTextHeader>
        {secondaryText && (
          <StyledExperimentSummarySecondaryText>
            {secondaryText}
          </StyledExperimentSummarySecondaryText>
        )}
      </StyledExperimentsTextContainer>
    </StyledExperimentsSummaryInfoBanner>
  );
};
